import React, { Component } from "react";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ScrollAnimation from "react-animate-on-scroll";
import { Styles } from "./styles/vision.js";

class Vision extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper vision-page">
          {/* Header */}
          <Header />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Vision" img="slider1.jpg" />

          {/* Vision Content */}
          <section className="vision-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <ScrollAnimation animateIn="fadeInUp" duration={1}>
                    <div className="vision-content">
                      <div className="vision-header">
                        <div className="vision-icon">
                          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5S21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12S9.24 7 12 7S17 9.24 17 12S14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12S10.34 15 12 15S15 13.66 15 12S13.66 9 12 9Z" fill="#6A5ACD"/>
                          </svg>
                        </div>
                        <h2 className="vision-title">Vision</h2>
                      </div>
                      
                      <div className="vision-text">
                        <p>
                          To achieve citywide inclusive sanitation and waste management for all by strengthening 
                          systems, institutions, and investments that ensure equitable, safe, and sustainable 
                          inclusive sanitation services across Bangladesh.
                        </p>
                      </div>

                      <div className="vision-pillars">
                        <div className="pillar-item">
                          <div className="pillar-icon">
                            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="#4CAF50"/>
                              <path d="M2 17L12 22L22 17" stroke="#4CAF50" strokeWidth="2" fill="none"/>
                              <path d="M2 12L12 17L22 12" stroke="#4CAF50" strokeWidth="2" fill="none"/>
                            </svg>
                          </div>
                          <div className="pillar-content">
                            <h3>Strengthening Systems</h3>
                            <p>Building robust infrastructure and operational frameworks for sustainable sanitation management</p>
                          </div>
                        </div>

                        <div className="pillar-item">
                          <div className="pillar-icon">
                            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#FF9800"/>
                              <path d="M19 15L20.25 18.5L24 19L20.25 19.5L19 23L17.75 19.5L14 19L17.75 18.5L19 15Z" fill="#FF9800"/>
                            </svg>
                          </div>
                          <div className="pillar-content">
                            <h3>Institutional Excellence</h3>
                            <p>Developing capable institutions with strong governance and regulatory frameworks</p>
                          </div>
                        </div>

                        <div className="pillar-item">
                          <div className="pillar-icon">
                            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14ZM12.6 10C11.8 7.7 9.6 6 7 6S2.2 7.7 1.4 10H12.6ZM21 10V8L15 8.5V10M15 12.5V10.5L21 10V12L15 12.5ZM21 14V12L15 12.5V14.5L21 14ZM22 22H2L4 20L2 18L4 16L2 14L4 12L2 10L4 8L2 6L4 4L2 2H22V22Z" fill="#2196F3"/>
                            </svg>
                          </div>
                          <div className="pillar-content">
                            <h3>Strategic Investments</h3>
                            <p>Ensuring sustainable financing and resource allocation for inclusive sanitation services</p>
                          </div>
                        </div>

                        <div className="pillar-item">
                          <div className="pillar-icon">
                            {/* People & access icon to represent equity */}
                            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              {/* Central person */}
                              <circle cx="12" cy="8" r="3" fill="#E91E63"/>
                              {/* Side persons */}
                              <circle cx="6" cy="10" r="2" fill="#E91E63" opacity="0.85"/>
                              <circle cx="18" cy="10" r="2" fill="#E91E63" opacity="0.85"/>
                              {/* Group base representing shared access */}
                              <path d="M12 12c-3 0-6 1.5-6 4v2h12v-2c0-2.5-3-4-6-4z" fill="#E91E63" opacity="0.25"/>
                              {/* Support arcs indicating inclusive reach */}
                              <path d="M4 18v-1c0-1.7 2-3 4-3" stroke="#E91E63" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
                              <path d="M20 18v-1c0-1.7-2-3-4-3" stroke="#E91E63" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
                            </svg>
                          </div>
                          <div className="pillar-content">
                            <h3>Equitable Access</h3>
                            <p>Ensuring safe and sustainable sanitation services reach all communities across Bangladesh</p>
                          </div>
                        </div>
                      </div>

                      {/* <div className="vision-impact">
                        <div className="impact-header">
                          <h3>Our Vision Impact</h3>
                        </div>
                        <div className="impact-stats">
                          <div className="stat-item">
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Citywide Coverage</div>
                          </div>
                          <div className="stat-item">
                            <div className="stat-number">∞</div>
                            <div className="stat-label">Inclusive Access</div>
                          </div>
                          <div className="stat-item">
                            <div className="stat-number">♻️</div>
                            <div className="stat-label">Sustainable Solutions</div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <Footer />
        </div>
      </Styles>
    );
  }
}

export default Vision;